var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2489 60.1572C75.9867 59.919 76.6039 59.6916 77.081 59.5035C75.4407 63.3152 72.9888 66.7185 69.8958 69.4675C66.5045 72.4815 62.4431 74.6193 58.059 75.6986C53.6748 76.7779 49.0977 76.7669 44.7187 75.6663C40.3397 74.5658 36.2885 72.4083 32.9114 69.3779C29.5344 66.3474 26.9319 62.5339 25.3269 58.263C23.7219 53.992 23.1624 49.3911 23.6962 44.8533C24.23 40.3156 25.8412 35.9766 28.3918 32.207C30.7018 28.7928 34.1856 26.1104 37.8354 24.0231C37.6944 24.565 37.5254 25.2789 37.3601 26.1338C36.9658 28.1736 36.5915 31.023 36.6724 34.2625C36.8342 40.7419 38.8211 48.8191 46.1502 55.0607C53.4669 61.2916 61.4952 62.2783 67.6726 61.7117C70.7598 61.4286 73.3898 60.7576 75.2489 60.1572Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.705b0c3a.svg";
export { ForwardRef as ReactComponent };